export class SubscriptionSavings {
  message: string = '';
  savings: number = 0;
  tierName: string = '';

  deserialize(input: any): this {
    Object.assign(this, input);
    if (typeof this.savings === 'number') {
      this.savings = this.savings / 100;
    }
    return this;
  }
}
